import React from 'react';
import VersionHistorySummaryGrid from 'components/v2/compiler/version-history/VersionHistorySummaryGrid';
import { useVersionLogContext } from '../hooks/useVersionLogContext';
import { VersionLogKeyValueTableRecord } from '../records/VersionLogKeyValueTableRecord';
import { ResolvedRowValue, resolveRow } from '../valueFormat';

const KeyValueTableRenderer: React.FC<VersionLogKeyValueTableRecord> = ({ rows }) => {
  const { data, metadata, dataSources, properties } = useVersionLogContext();
  const resolvedRows = rows
    .map((row) => resolveRow(row, data, metadata, dataSources, properties))
    .filter((row): row is ResolvedRowValue => row !== null);
  return <VersionHistorySummaryGrid rows={resolvedRows} />;
};

export default KeyValueTableRenderer;
